import { useState } from 'react';
import { Modal } from '@mui/material';
import PartialLoader from 'components/layout/PartialLoader';
import { Button } from 'tt-ui-lib/core';
import ModalContainer from 'components/ModalContainer';
import styles from './DeleteModal.module.scss';

const DeleteModal = ({ isModelOpen, isDeleteLoading = false, setIsOpen, onDelete, modalText }) => (
  <>
    {isModelOpen && (
      <Modal
        open={isModelOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        classes={{
          root: styles.modalRoot,
        }}
        BackdropProps={{ style: { backgroundColor: 'transparent' } }}
      >
        <ModalContainer
          className={styles.deleteModalWrapper}
          handleClose={() => setIsOpen(false)}
          isPasswordUpdateModal
        >
          <div className={styles.modalTitle}>Delete</div>
          <div className={styles.modalText}>{modalText}</div>
          <div className={styles.buttonWrapper}>
            <Button type="default" className={styles.cancelBtn} onClick={() => setIsOpen(false)}>
              Cancel
            </Button>
            <Button type="primary" className={styles.deleteBtn} onClick={onDelete}>
              Delete
            </Button>
          </div>
          <PartialLoader loading={isDeleteLoading} isLightContainer />
        </ModalContainer>
      </Modal>
    )}
  </>
);

export default DeleteModal;
